import { useEffect, useState } from 'react';
import { format } from '../../../../helpers/formatter';

import { useShopingCart } from '../../hooks/useShopingCart';
import './ResumeCard.css';

const safeValue = (value) => (isNaN(value) ? 0 : value);

export const ResumeCardChild = ({
  monto_con_iva,
  monto_neto,
  precio_iva,
  porc_descuento,
  descuento,
  onObservacionesChange,
  observacionesResume,
  editable = true,
}) => {
  const { currencyCart } = useShopingCart();
  const calcularTotalConDescuento = (finalPrice, desClie) => {
    if (!desClie) return finalPrice; // Si desClie es 0, null, undefined, etc.
    const descuento = (finalPrice * desClie) / 100;

    return finalPrice - descuento;
  };

  //ARMADO DE PEDIDO

  const [observaciones, setObservaciones] = useState(observacionesResume || '');
  const finalPrice = monto_neto * (1 - porc_descuento / 100) + precio_iva;

  //let descuentazo = monto_neto / porc_descuento;
  let total_desc = calcularTotalConDescuento(monto_neto, porc_descuento);
  let descuentazo = monto_neto - total_desc;

  if (descuentazo === Infinity) {
    descuentazo = 0;
  }

  useEffect(() => {
    setObservaciones(observacionesResume || '');
  }, [observacionesResume]);

  const calcularPorcentajeIVA = () => {
    if (monto_neto === 0 || isNaN(monto_neto)) return 0;
    return ((monto_con_iva - monto_neto) / monto_neto) * 100;
  };

  const porcentajeIVA = calcularPorcentajeIVA();

  let precioSinIvaConDescuento = finalPrice / (1 + porcentajeIVA / 100);

  let ivaAplicado = finalPrice - precioSinIvaConDescuento;

  const handleObservacionesChange = (e) => {
    if (!editable) return;

    const value = e.target.value;
    setObservaciones(value);
    if (onObservacionesChange) {
      onObservacionesChange(value);
    }
  };

  useEffect(() => {
    setObservaciones(observacionesResume || '');
  }, [observacionesResume]);

  return (
    <>
      <section className="contenedorTotal">
        <div className="summary">
          <div className="resumeItems">
            <span>Precio con iva</span>
            <span>
              {format.currency(currencyCart, safeValue(monto_con_iva))}
            </span>
          </div>
          <div className="resumeItems">
            <span>Precio sin Iva</span>
            <span>{format.currency(currencyCart, safeValue(monto_neto))}</span>
          </div>
          {porc_descuento && (
            <div className="resumeItems">
              <span>Descuento</span>
              <span>
                {`(${format.percent(porc_descuento)}) ${format.currency(currencyCart, safeValue(descuentazo))}`}
              </span>
            </div>
          )}
          <div className="resumeItems">
            <span>Precio Iva</span>
            <span>{format.currency(currencyCart, safeValue(precio_iva))}</span>
          </div>
          <div className="resumeItems">
            <span>Total</span>
            <span className="styleTotal">
              {format.currency(currencyCart, safeValue(finalPrice))}
            </span>
          </div>

          {/* <div className="observaciones">
            <div className="obs_titulo">
              <span>Observaciones</span>
            </div>
            <div className="obs_text">
              <span className="resumeItems">
                <textarea
                  value={observaciones}
                  onChange={handleObservacionesChange}
                  readOnly={!editable}
                  className={!editable ? 'read-only-textarea' : ''}
                />
              </span>
            </div>
          </div> */}

          <div className="observaciones">
            <div className="obs_titulo">
              <span>Observaciones de Retiro:</span>
            </div>
            <div className="obs_text">
              <span className="resumeItems">
                {editable ? (
                  <textarea
                    value={observaciones}
                    onChange={handleObservacionesChange}
                    className="textarea"
                  />
                ) : (
                  // <p
                  //   className="observaciones-text"
                  //   style={{ fontStyle: 'italic' }}
                  // >
                  //   {observaciones || 'Sin observaciones'}
                  // </p>
                  <textarea
                    value={observaciones}
                    onChange={handleObservacionesChange}
                    readOnly={!editable}
                    className={!editable ? 'read-only-textarea' : ''}
                  />
                )}
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
